module.exports = __webpack_public_path__ + "img/js.4ef16d15.png";